export enum TypeOfPaymentsLabel {
  BOLETO,
  CARNE,
  CARTAO_CREDITO,
  DINHEIRO,
  PIX,
  CARTAO_DEBITO
}

export enum TypeOfPaymentsEnum {
  BOLETO = 'Boleto',
  CARNE = 'Carnê',
  CARTAO_CREDITO = 'Cartão de Crédito',
  DINHEIRO = 'Dinheiro',
  PIX = 'PIX',
  CARTAO_DEBITO = 'Cartão de Débito'
}
